
window.VueEventBus.$on('billing.before.submit.async', listeners => {
    listeners.push(async (payload) => {
        if (window.grecaptcha && window.addiesaas.recaptcha.site_key) {
            payload.re_captcha_token = await window.grecaptcha.execute(window.addiesaas.recaptcha.site_key, { action: 'pay' })
        }
    })
})
